import { CommonModule, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Item } from '../../interfaces/api-response';

@Component({
  selector: 'career-content-job',
  standalone: true,
  imports: [NgIf, CommonModule],
  templateUrl: './content-job.component.html',
  styleUrls: ['./content-job.component.scss'],
})
export class ContentJobComponent {
  @Input() job: Item | null = null;
  @Input() loading: boolean = false;

  getIconPath(type: string): string {
    const iconMap: { [key: string]: string } = {
      workfields: '/angular/browser/img/icons/workfields.svg',
      employment: '/angular/browser/img/icons/employment.svg',
      city: '/angular/browser/img/icons/location.svg',
      education: '/angular/browser/img/icons/education.svg',
    };
    return iconMap[type] || '';
  }
}
